import React from "react";
import { Wifi, MousePointerClick, UserPlus, CreditCard, AlertTriangle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { useReveal } from "../hooks/useReveal";

const stepIcons = [Wifi, MousePointerClick, UserPlus, CreditCard];

export default function HowItWorks() {
  const { t } = useLanguage();
  const { ref, visible } = useReveal();

  return (
    <section id="come-funziona" className="py-20 lg:py-28 bg-gradient-to-b from-white to-secondary/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-primary font-semibold text-sm tracking-[0.18em] uppercase">
            {t.how.eyebrow}
          </span>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[30px] sm:text-[40px] leading-tight tracking-[-0.02em]">
            {t.how.title}
          </h2>
          <p className="mt-4 text-[16px] text-slate-700">{t.how.subtitle}</p>
        </div>

        <div ref={ref} className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.how.steps.map((step, i) => {
            const Icon = stepIcons[i];
            return (
              <div
                key={i}
                className={`relative group bg-white rounded-2xl p-6 border border-slate-100 hsc-card-shadow hover:-translate-y-1.5 transition-transform duration-300 hsc-reveal ${
                  visible ? "is-visible" : ""
                }`}
                style={{ animationDelay: `${i * 110}ms` }}
              >
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center w-12 h-12 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                    <Icon className="w-6 h-6" strokeWidth={2.2} />
                  </span>
                  <span className="font-display font-extrabold text-5xl text-slate-100 group-hover:text-primary/15 transition-colors leading-none">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-display font-bold text-[17px] text-slate-900">{step.title}</h3>
                <p className="mt-2 text-[14px] leading-relaxed text-slate-700">{step.desc}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-10 rounded-2xl border border-accent/30 bg-accent/10 p-5 sm:p-6 flex gap-4">
          <span className="grid place-items-center w-11 h-11 rounded-xl bg-accent/20 text-accent-foreground shrink-0">
            <AlertTriangle className="w-6 h-6" strokeWidth={2.2} />
          </span>
          <div>
            <h4 className="font-display font-bold text-[15px] text-slate-900 uppercase tracking-wide">
              {t.how.warningTitle}
            </h4>
            <p className="mt-1.5 text-[14px] leading-relaxed text-slate-700">{t.how.warning}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
